import useSWR from "swr";

// Fetch function to get the items from the API
const fetchData = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch Data");
    }
    return response.json();
  } catch (error) {
    console.log({ error: error?.message ?? error });
  }
};

const useGetParamsData = (
  queryParams = "",
  url = "/server/dealer_backend/items"
) => {
  // Construct the dynamic URL based on query parameters
  const constructedUrl = `${url}${queryParams ? `?${queryParams}` : ""}`;

  const { data, error, isLoading } = useSWR(constructedUrl, fetchData);

  return {
    data,
    isLoading: isLoading, // Use this to properly handle loading state
    isError: error,
  };
};

export default useGetParamsData;
